import { Box, CircularProgress, Typography } from "@mui/material";

export function ContactCenterLoadingBody({ message }: { message?: string }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        width: "100%",
        height: "100%",
        minHeight: 180,
        p: 3,
      }}
    >
      <CircularProgress size={24} />
      {message ? (
        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
          {message}
        </Typography>
      ) : null}
    </Box>
  );
}
